/**
 * Rules for when the "Confirmă" button of a question may be pressed.
 * Kept out of QuizTaking so they can be tested without rendering the page.
 */

/**
 * Multi-answer question: the child must have picked exactly as many options as
 * the server says are correct. `correctCount` comes with the question when the
 * attempt starts. If it is missing (an older server, a question without a
 * usable answer key) any non-empty pick is allowed, as before.
 */
export function canSubmitMulti(selectedCount: number, correctCount: number | null | undefined): boolean {
  if (selectedCount < 1) return false;
  if (typeof correctCount !== "number" || correctCount < 1) return true;
  return selectedCount === correctCount;
}

/** True/false question: one of the two buttons has to be picked (false counts). */
export function canConfirmTrueFalse(answer: unknown): boolean {
  return answer === true || answer === false;
}
